import { render, staticRenderFns } from "./assign-menu.vue?vue&type=template&id=02502232&scoped=true&"
import script from "./assign-menu.vue?vue&type=script&lang=js&"
export * from "./assign-menu.vue?vue&type=script&lang=js&"
import style0 from "./assign-menu.vue?vue&type=style&index=0&id=02502232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02502232",
  null
  
)

export default component.exports